import {ArrowBack} from '@mui/icons-material';
import {Button, CircularProgress, Stack} from '@mui/material';

export interface AdminSeedQuestionHeaderProps {
  onBack: () => void;
  onSave: () => void;
  onGeneratePrompt: () => void;
  updateLoading: boolean;
}

export default function AdminSeedQuestionHeader({
  onBack,
  onSave,
  onGeneratePrompt,
  updateLoading,
}: AdminSeedQuestionHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 3}}>
      <Button
        startIcon={<ArrowBack />}
        onClick={onBack}
        sx={{
          color: '#1B263B',
          '&:hover': {bgcolor: 'rgba(27, 38, 59, 0.04)'},
        }}
      >
        Back to Seed Questions
      </Button>
      <Button
        onClick={onGeneratePrompt}
        variant="outlined"
        disabled={updateLoading}
        sx={{
          borderColor: '#FF6F59',
          color: '#FF6F59',
          '&:hover': {borderColor: '#FF6F59', bgcolor: '#FF6F59', color: 'white'},
        }}
      >
        Generate Variants
      </Button>
      <Button
        onClick={onSave}
        variant="contained"
        disabled={updateLoading}
        sx={{
          bgcolor: '#1B263B',
          '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
        }}
      >
        {updateLoading ? <CircularProgress size={20} color="inherit" /> : 'Save Changes'}
      </Button>
    </Stack>
  );
}
